<template>
  <div id="checkpoints_page">
    <div style="display: flex; justify-content: space-between">
      <h1>{{ $i18n.t('pages.checkpoints.title') }}</h1>

      <v-btn
        v-if="loadingOverlay.reload_required"
        class="white--text mr-1 ml-1"
        color="#DBEAF1"
        elevation="0"
        height="42"
        @click="send_system_reload_message"
      >
        <span class="main_color button-font">{{ $i18n.t('general.system_reboot') }}</span>
      </v-btn>
    </div>

    <v-tabs v-model="current_tab" style="margin-top: 15px;" background-color="transparent">
        <v-tab><span class="tab-font">{{ $i18n.t('pages.checkpoints.checkpoints') }}</span></v-tab>
        <v-tab><span class="tab-font">{{ $i18n.t('pages.checkpoints.gates') }}</span></v-tab>
      <v-tab-item>
        <v-card id="checkpoints_card" class="tab_card">
            <v-card-title>
              <span class="main_card_title" style="margin-top: 15px">{{ $i18n.t('pages.checkpoints.checkpoints') }}</span>
            </v-card-title>
            <v-card-text>
                <v-data-table
                  :headers="checkpoints_table_headers"
                  :items="form_aps_table_data"
                  :footer-props="{
                  itemsPerPageText: $i18n.t('table_footers.rows_per_page'),
                  itemsPerPageOptions: [10, 20, 30, 50],
                  }"
                >
                  <template #footer.page-text="props">
                  {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                  </template>
                  <template v-slot:item="{item, index}">
                      <tr :key="index">
                        <td>
                            {{item.name}}
                        </td>
                        <td>
                          <div>
                            <v-btn icon small @click="open_checkpoint_editor(item)"><v-icon>$icon_edit</v-icon></v-btn>
                            <v-btn icon small @click="delete_checkpoint(item)"><v-icon>$icon_trash</v-icon></v-btn>
                          </div>
                        </td>
                        <td style="width: 200px">
                          <table style="width: 100%">
                            <tr v-for="gate in item.gates" :key="gate._id['$oid']">
                              <td style="display: flex; justify-content: space-between">
                                  {{gate.name}}
                                  <div>
                                    <v-btn icon small @click="open_gate_editor(gate)"><v-icon>$icon_edit</v-icon></v-btn>
                                    <v-btn icon small @click="delete_gate(gate)"><v-icon>$icon_trash</v-icon></v-btn>
                                  </div>

                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                  </template>
                </v-data-table>
            </v-card-text>
        </v-card>
      </v-tab-item>
      
      <v-tab-item>
        <v-card id="gates_card" class="tab_card">
            <v-card-title>
              <span class="main_card_title" style="margin-top: 15px">{{ $i18n.t('pages.checkpoints.gates') }}</span>
            </v-card-title>
            <v-card-text>
                <v-data-table
                :headers="gates_table_headers"
                :items="form_gates_table_data"
                :footer-props="{
                itemsPerPageText: $i18n.t('table_footers.rows_per_page'),
                itemsPerPageOptions: [5, 10, 15, 20],
                }"
                >
                  <template #footer.page-text="props">
                  {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                  </template>
                  <template v-slot:item="{item, index}">
                      <tr :key="index">
                        <td>
                          {{item.name}}
                        </td>
                        <td>
                          <div>
                             <v-btn icon small @click="open_gate_editor(item)"><v-icon>$icon_edit</v-icon></v-btn>
                             <v-btn icon small @click="delete_gate(item)"><v-icon>$icon_trash</v-icon></v-btn>
                          </div>
                        </td>
                        <td>
                          <table class="table">
                            <tr v-for="cam in item.cams" :key="cam._id['$oid']">
                              <td>{{cam.name}}</td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table class="table">
                            <tr v-for="relay in item.relays" :key="relay._id['$oid']">
                              <td>{{relay.name}}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                  </template>
                </v-data-table>
            </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <v-dialog eager v-model="checkpoint_edit_dialog" max-width="420px">
        <v-card style="border-radius: 8px" elevation="0">
            <v-card-title>
              <span>{{form_checkpoint_editor_title}}</span>
            </v-card-title>
            <v-card-text style="padding: 0 15px 30px">
              <v-form class="edit_card_container" v-model="checkpoint_edit_valid" ref="checkpoint_edit_valid">
                <v-subheader class="subheader">{{ $i18n.t('pages.checkpoints.dialog.enter_title') }}</v-subheader>
                <v-text-field
                    class="rounded_8px height_56px"
                    outlined
                    v-model="edited_checkpoint.name"
                    :placeholder="$i18n.t('pages.checkpoints.dialog.enter_title')"
                    :rules="validation_rules.name"
                />
                <v-subheader class="subheader margin-t">{{ $i18n.t('pages.checkpoints.dialog.gates') }}</v-subheader>
                  <v-select ref="gate_select"
                   outlined
                   class="rounded_8px"
                   :placeholder="$i18n.t('pages.checkpoints.dialog.gates')"
                   :items="gates"
                   v-model="edited_checkpoint.gates"
                   item-text="name"
                   item-value="_id"
                   multiple
                   chips
                   small-chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        @click="open_gate_editor(data.item)"
                      >
                        {{data.item.name}}: {{direction_type_readable[data.item.type]}}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <div class="d-flex justify-space-between" style=" width: 100%">
                        <span> {{data.item.name}}: {{direction_type_readable[data.item.type]}},
                              {{gate_checkpoint_name(data.item)}}
                        </span>
                        <div>
                          <v-btn icon class="mr-2" small @click="open_gate_editor(data.item)">
                            <v-icon class="white--text">$icon_edit</v-icon>
                          </v-btn>
                          <v-btn icon class="ml-2" fab color="#207ea9" small @click="delete_gate(data.item)">
                              <v-icon class="white--text">$icon_trash</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </template>
                  </v-select>
              </v-form>

              <div style="padding:30px 15px 0 15px; display: flex; justify-content: space-between">
                <v-btn
                  class=" white--text"
                  height="42"
                  color="#DBEAF1"
                  elevation="0"
                  style="width: 170px"
                  @click="checkpoint_edit_dialog = false"
                >
                  <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
                </v-btn>
                <v-btn
                    class="white--text"
                    style="width: 170px"
                    height="42"
                    elevation="0"
                    color="#207ea9"
                    @click="save_checkpoint"
                >
                  <span class="button-font">{{ $i18n.t('general.save') }}</span>
                </v-btn>
              </div>
            </v-card-text>    
          </v-card>
      </v-dialog>
      <v-dialog v-model="gate_edit_dialog" max-width="420">
        <v-card style="border-radius: 8px" elevation="0">
          <v-card-title>
            <span>{{form_gate_editor_title}}</span>
          </v-card-title>
          <v-card-text style="padding: 0 15px 30px">
            <v-form class="edit_card_container" v-model="gate_edit_valid" ref="gate_edit_valid">
              <v-subheader class="subheader">{{ $i18n.t('pages.checkpoints.dialog.enter_title') }}</v-subheader>
              <v-text-field
                  class="height_56px rounded_8px"
                  outlined
                  :placeholder="$i18n.t('pages.checkpoints.dialog.enter_title')"
                  v-model="edited_gate.name"
                  :rules="validation_rules.name"
              />
              <v-subheader class="subheader margin-t">{{ $i18n.t('pages.checkpoints.dialog.access_direction') }}</v-subheader>
              <v-select
                  outlined
                  class="height_56px rounded_8px"
                  :placeholder="$i18n.t('pages.checkpoints.dialog.access_direction')"
                  :items="direction_types"
                  v-model="edited_gate.type"
                  :rules="validation_rules.direction"
              />
              <v-subheader class="subheader margin-t">{{ $i18n.t('pages.checkpoints.dialog.cameras') }}</v-subheader>
              <v-select
                 outlined
                 class="rounded_8px"
                 :placeholder="$i18n.t('pages.checkpoints.dialog.cameras')"
                 :items="cams"
                 item-text="name"
                 item-value="_id"
                 multiple chips small-chips
                 v-model="edited_gate.cams"
                 v-on:focusout="check_cross_line_detection()"
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                  >
                    {{data.item.name}}: {{direction_type_readable[data.item.direction]}}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <div class="d-flex justify-space-between" style=" width: 100%">
                      <span> {{data.item.name}}: {{direction_type_readable[data.item.direction]}} </span>
                  </div>
                </template>
              </v-select>
              <div style="display: flex; justify-content: start" class="vuetify_sucks">
                <v-checkbox
                    hide-details
                    :ripple="false"
                    class="my_ass"
                    v-model="edited_gate.all_addressees_selected"
                    @change="set_all_addressees_selection_status(edited_gate.all_addressees_selected)"
                />
                <v-subheader class="subheader">
                  <span>{{ $i18n.t('pages.checkpoints.dialog.locations') }}</span>
                </v-subheader>
              </div>
              <v-select
                multiple
                chips
                small-chips
                outlined
                class="rounded_8px"
                :placeholder="$i18n.t('pages.checkpoints.dialog.locations')"
                :items="addressees"
                item-text="name"
                item-value="external_id"
                v-model="edited_gate.addressees_external_ids"
              >
                <template v-slot:selection="{item, index}">
                  <v-chip v-if="index < 4">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 4" class="grey--text caption">
                    (+{{ edited_gate.addressees_external_ids.length - 3 }})
                  </span>
                </template>
              </v-select>
              <v-subheader class="subheader" v-if="edited_gate.cross_line_detection" >
                      <span>{{ $i18n.t('pages.checkpoints.dialog.opening_time') }}</span>
              </v-subheader>
              <v-slider
                v-if="edited_gate.cross_line_detection"
                style="width: 550px"
                thumb-label
                thumb-size="20"
                :min="1"
                :max="120"
                v-model="edited_gate.opening_time"
                :disabled="!edited_gate.cross_line_detection"
              >
              </v-slider>
              <v-subheader class="subheader" v-if="edited_gate.cross_line_detection" >
                <span>{{ $i18n.t('pages.checkpoints.dialog.closing_delay_time') }}</span>
              </v-subheader>
              <v-slider
                v-if="edited_gate.cross_line_detection"
                style="width: 550px"
                thumb-label
                thumb-size="20"
                :min="1"
                :max="120"
                v-model="edited_gate.closing_delay_time"
                :disabled="!edited_gate.cross_line_detection"
              >
              </v-slider>
              <v-subheader class="subheader" v-if="edited_gate.cross_line_detection" >
                <span>{{ $i18n.t('pages.checkpoints.dialog.closing_time') }}</span>
              </v-subheader>
              <v-slider
                v-if="edited_gate.cross_line_detection"
                style="width: 550px"
                thumb-label
                thumb-size="20"
                :min="1"
                :max="120"
                v-model="edited_gate.closing_time"
                :disabled="!edited_gate.cross_line_detection"
              >
              </v-slider>
            </v-form>
            <div style="padding:15px 15px 0 15px; display: flex; justify-content: space-between">
                <v-btn
                  class=" white--text"
                  height="42"
                  color="#DBEAF1"
                  elevation="0"
                  style="width: 170px"
                  @click="gate_edit_dialog = false"
                >
                  <span style="color: #207EA9" class="button-font">{{ $i18n.t('general.close') }}</span>
                </v-btn>
                <v-btn
                    class="white--text"
                    style="width: 170px"
                    height="42"
                    elevation="0"
                    color="#207ea9"
                    @click="save_gate"
                >
                  <span class="button-font">{{ $i18n.t('general.save') }}</span>
                </v-btn>
              </div>
          </v-card-text>
        </v-card>  
      </v-dialog>

    <div class="plus-button-component-positioning">
        <div style="display: flex; flex-wrap: wrap; justify-content: center">
          <v-btn
            class="white--text"
            elevation="0"
            fab
            height="72px"
            width="72px"
            @click="current_tab ? add_gate() : add_checkpoint()"
          >
            <v-icon size="72px">$icon_rounded_plus</v-icon>
          </v-btn>
        </div>
    </div>
  </div>
</template>

<script>
// import {EventBus} from "@/bus";
import {i18n} from "@/i18n";
import {mapActions, mapGetters} from "vuex";
import {common_funcs} from "@/mixins/common";
export default {
  name: "CheckpointsAndGatesPage",
  mixins: [common_funcs],
  data: function () {
    this.fetch_checkpoints_data()
    this.fetch_relays_data()
    this.fetch_addressees_data()
    return {
      plus_was_pressed: false,
      current_tab: null,

      checkpoints: [],
      gates: [],
      cams: [],
      relays: [],
      addressees: [],
      checkpoint_edit_dialog: false,
      gate_edit_dialog: false,
      entity_edit_overlay: false,
      cross_line_editor: false,


      checkpoint_edit_valid: true,
      gate_edit_valid: true,
      validation_rules: {
        name: [
            v => !!v || i18n.t('validation.this_field_is_required')
        ],
        direction: [
            v => !!v || i18n.t('validation.this_field_is_required')
        ]
      },

      default_checkpoint: {name: '', gates: ''},
      edited_checkpoint: {name: '', gates: ''},

      edited_checkpoint_index: -1,
      edited_gate_index: -1,

      default_gate: {
        name: '',
        cams: '',
        type: '',
        checkpoint_id: null,
        addressees_external_ids: [],
        all_addressees_selected: false,
        opening_time: null,
        closing_time: null,
        closing_delay_time: null,
        cross_line_detection: false
      },
      edited_gate: {
        name: '',
        cams: '',
        type: '',
        checkpoint_id: null,
        addressees_external_ids: [],
        all_addressees_selected: false,
        opening_time: null,
        closing_time: null,
        closing_delay_time: null,
        cross_line_detection: false
      },
      direction_types: [
          {text: i18n.t('general.direction_entry'), value: 'entry'},
          {text: i18n.t('general.direction_exit'), value: 'exit'},
          {text: i18n.t('general.direction_entry_exit'), value: 'entry_exit'}
      ],
      direction_type_readable: {
        'entry': i18n.t('general.direction_entry'),
        'exit': i18n.t('general.direction_exit'),
        'entry_exit': i18n.t('general.direction_entry_exit')
      },
      checkpoints_table_headers: [
        { text: i18n.t('pages.checkpoints.table.headers.ap_name'),
          value: 'name', align: 'start', width: '30%'
        },
        { text: i18n.t('pages.checkpoints.table.headers.actions'),
          value: 'actions', align: 'start', sortable: false,
        },
        { text: i18n.t('pages.checkpoints.table.headers.gates'),
          value: 'gates', align: 'center', sortable: false, width: '45%'
        },
      ],

      gates_table_headers: [
        { text: i18n.t('pages.checkpoints.table.headers.gates'),
          value: 'name', align: 'start', width: '30%'
        },
        { text: i18n.t('pages.checkpoints.table.headers.actions'),
          value: 'actions', align: 'start', sortable: false
        },
        { text: i18n.t('pages.checkpoints.table.headers.cameras'),
          value: 'gates', sortable: false, width: '20%'
        },
        { text: i18n.t('pages.checkpoints.table.headers.relays'),
          value: 'gates', sortable: false, width: '20%'
        },
      ]
    }
  },
  methods: {
    check_cross_line_detection: function (){
      for (let cam of this.cams) {
        for (let cam_in_gate of this.edited_gate.cams) {
          if (cam._id["$oid"] === cam_in_gate['$oid']) {
            if (cam["cross_line_detection"] === true) {
              console.log(true)
              this.edited_gate["cross_line_detection"] = true
              return
            }
          }
        }
      }
      this.edited_gate["cross_line_detection"] = false
      console.log(this.edited_gate)
    },
    enable_cross_line_detection: function(){
      if (!this.edited_gate.cross_line_detection){
        this.edited_gate.cross_line_detection = true
        this.cross_line_editor = true
      }
      else{
        this.edited_gate.cross_line_detection = false
        this.cross_line_editor = false
      }
      console.log(this.edited_gate.cross_line_detection)

    },
     fetch_checkpoints_data: function () {
      let t = this
      this.$http({url: this.$http_hostname + '/checkpoints_and_gates/get_all', method: 'GET'})
      .then(resp => {
        t.checkpoints = resp.data.checkpoints
        t.gates = resp.data.gates
        t.cams = resp.data.cams
      })
      .catch(() => {
        this.setSnackbar({
          text: i18n.t('notifications.error_during_data_loading'),
        })
      })
    },
    fetch_relays_data: function () {
      let t = this
      this.$http({url: this.$http_hostname + '/viport_relays_settings/all', method: 'GET'})
      .then(resp => {
        t.relays = resp.data.relays
      })
      .catch(() => {
        t.setSnackbar({
          text: i18n.t('notifications.error_during_data_loading'),
        })
      })
    },
    fetch_addressees_data: function () {
      let t = this
      this.$http({url: this.$http_hostname + '/addressees/all', method: 'GET'})
      .then(resp => {
        t.addressees = resp.data
      })
      .catch(() => {
        t.setSnackbar({
            text: i18n.t('notifications.error_during_data_loading'),
          })
      })
    },
    add_checkpoint: function () {
      this.open_checkpoint_editor()
    },
    add_gate: function () {
      this.open_gate_editor()
    },

    cams_by_gate_id: function (gate_id) {
       let cams_in_gate = []
        for (let cam of this.cams) {
          if (cam.gate_id === null) continue
          if (cam.gate_id['$oid'] === gate_id['$oid']) {
            cams_in_gate.push(cam)
          }
        }
        return cams_in_gate
    },
    relays_by_gate_id: function (gate_id) {
      let relays_in_gate = []
        for (let relay of this.relays) {
          if (relay.gate_id === null) continue
          if (relay.gate_id['$oid'] === gate_id['$oid']) {
            relays_in_gate.push(relay)
          }
        }
        return relays_in_gate
    },

    open_checkpoint_editor: function (checkpoint) {
        this.edited_checkpoint_index = this.checkpoints.indexOf(checkpoint)
        let gates_ids = []
        if (this.edited_checkpoint_index > -1) {
          checkpoint.gates.forEach(gate => gates_ids.push(gate._id))
          this.edited_checkpoint = Object.assign({}, checkpoint)
        }
        this.edited_checkpoint.gates = gates_ids
        this.checkpoint_edit_dialog = true
      },
      open_gate_editor: function (gate) {
        this.edited_gate_index = this.gates.indexOf(gate)
        let cams_ids = []
        if (this.edited_gate_index > -1) {
          gate.cams.forEach(cam => cams_ids.push(cam._id))
          this.edited_gate = Object.assign({}, gate)
        }
        this.edited_gate.cams = cams_ids
        this.gate_edit_dialog = true
      },
      close_checkpoint_editor: function () {
        this.edited_checkpoint = Object.assign({}, this.default_checkpoint)
        this.edited_checkpoint_index = -1
        this.$refs.checkpoint_edit_valid.resetValidation()
      },
      close_gate_editor: function () {
        this.edited_gate = Object.assign({}, this.default_gate)
        this.edited_gate_index = -1
      },

      save_checkpoint: function () {
        if (!this.$refs.checkpoint_edit_valid.validate()) return
        let t = this
        let _edited_checkpoint = this.edited_checkpoint
        let data = {checkpoint: this.edited_checkpoint}
        if (this.edited_checkpoint_index === -1) {
           this.$http({url: this.$http_hostname + '/checkpoints_and_gates/add_checkpoint', data: data, method: 'POST'})
            .then(resp => {
              _edited_checkpoint._id = resp.data.new_checkpoint_id
              for(let gate_id of resp.data.linked_gates) {
                t.gates.find(gate => gate._id['$oid'] === gate_id['$oid']).checkpoint_id = resp.data.new_checkpoint_id
              }
              t.checkpoints.push(_edited_checkpoint)
              this.setSnackbar({
                text: i18n.t('notifications.checkpoints_and_gates.checkpoint_added', {ap_name: _edited_checkpoint.name})
              })
              this.set_reload_required()
            })
            .catch(error => {
              this.show_error_message(error)
            })
        } else {
          let checkpoint_to_edit = this.checkpoints.find(chp => chp._id['$oid'] === this.edited_checkpoint._id['$oid'])
          let checkpoint_index = this.checkpoints.indexOf(checkpoint_to_edit)
          this.$http({url: this.$http_hostname + '/checkpoints_and_gates/edit_checkpoint', data: data, method: 'POST'})
              // eslint-disable-next-line no-unused-vars
            .then(resp => {
             Object.assign(t.checkpoints[checkpoint_index], _edited_checkpoint)
              for (let gate_index in t.gates) {
                if (t.gates[gate_index].checkpoint_id !== null && t.gates[gate_index].checkpoint_id['$oid'] === _edited_checkpoint._id['$oid']) {
                  t.gates[gate_index].checkpoint_id = null
                }
              }
             for(let gate_id of resp.data.linked_gates) {
               t.gates.find(gate => gate._id['$oid'] === gate_id['$oid']).checkpoint_id = resp.data.edited_checkpoint_id
             }
             this.setSnackbar({
                text: i18n.t('notifications.checkpoints_and_gates.checkpoint_edited', {ap_name: _edited_checkpoint.name}),
              })
              this.set_reload_required()
            })
            .catch(error => {
              this.show_error_message(error)
            })
        }
        this.checkpoint_edit_dialog = false
        this.gate_edit_dialog = false
      },
      delete_checkpoint: function (checkpoint) {
        let t = this
        let data = {'checkpoint_id': checkpoint._id}
        confirm(i18n.t('submissions.delete_checkpoint', {ap_name: checkpoint.name})) &&
        this.$http({url: this.$http_hostname + '/checkpoints_and_gates/delete_checkpoint_by_id', data: data, method: 'DELETE'})
        .then(() => {
          console.log(this.checkpoints, t.checkpoints)
          t.checkpoints.splice(t.checkpoints.indexOf(checkpoint), 1)
          for (let gate_index in t.gates) {
            if (t.gates[gate_index].checkpoint_id !== null && t.gates[gate_index].checkpoint_id['$oid'] === checkpoint._id['$oid']) {
              t.gates[gate_index].checkpoint_id = null
            }
          }
          this.setSnackbar({
            text: i18n.t('notifications.checkpoints_and_gates.checkpoint_deleted', {ap_name: checkpoint.name})
          })
          this.set_reload_required()
        })
        .catch(error => {
          this.show_error_message(error)
        })
      },

      save_gate: function () {
        if (!this.$refs.gate_edit_valid.validate()) return
        let t = this
        let _edited_gate = this.edited_gate

        let data = {gate: this.edited_gate}
        if (this.edited_gate_index === -1) {
         this.$http({url: this.$http_hostname + '/checkpoints_and_gates/add_gate', data: data, method: 'POST'})
          .then(resp => {
            _edited_gate._id = resp.data.new_gate_id
            for(let cam_id of resp.data.linked_cams) {
                t.cams.find(cam => cam._id['$oid'] === cam_id['$oid']).gate_id = resp.data.new_gate_id
            }
            t.gates.push(_edited_gate)
            if (t.checkpoint_edit_dialog) {t.edited_checkpoint.gates.push(_edited_gate['_id'])}
            this.setSnackbar({
                text: i18n.t('notifications.checkpoints_and_gates.gate_added', {gate_name: _edited_gate.name}),
              })
            this.set_reload_required()
          })
          .catch(error => {
            this.show_error_message(error)
          })
        } else {
          let gate_to_edit = this.gates.find(gate => gate._id['$oid'] === this.edited_gate._id['$oid'])
          let gate_index = this.gates.indexOf(gate_to_edit)
          this.$http({url: this.$http_hostname + '/checkpoints_and_gates/edit_gate', data: data, method: 'POST'})
          .then(resp => {
            Object.assign(t.gates[gate_index], _edited_gate)
            for (let cam_index in t.cams) {
                if (t.cams[cam_index].gate_id !== null && t.cams[cam_index].gate_id['$oid'] === _edited_gate._id['$oid']) {
                  t.cams[cam_index].gate_id = null
                }
              }
            for(let cam_id of resp.data.linked_cams) {
                t.cams.find(cam => cam._id['$oid'] === cam_id['$oid']).gate_id = resp.data.edited_gate_id
              }
            this.setSnackbar({
                text: i18n.t('notifications.checkpoints_and_gates.gate_edited', {gate_name: _edited_gate.name}),
              })
            this.set_reload_required()
          })
          .catch(error => {
            this.show_error_message(error)
          })
        }
        this.gate_edit_dialog = false
      },
      delete_gate: function (gate) {
        let t = this
        let data = {'gate_id': gate._id}
        confirm(i18n.t('submissions.delete_gate', {gate_name: gate.name})) &&
        this.$http({url: this.$http_hostname + '/checkpoints_and_gates/delete_gate_by_id', data: data, method: 'DELETE'})
        .then(() => {
          t.gates.splice(t.gates.indexOf(gate), 1)
          for (let cam_index in t.cams) {
            if (t.cams[cam_index].gate_id !== null && t.cams[cam_index].gate_id['$oid'] === gate._id['$oid']) {
              t.cams[cam_index].gate_id = null
            }
          }
          for (let gate_index in t.edited_checkpoint.gates) {
            if (t.edited_checkpoint.gates[gate_index]['$oid'] === gate._id['$oid']) {
              t.edited_checkpoint.gates.splice(gate_index, 1)
            }
          }
          this.setSnackbar({
            text: i18n.t('notifications.checkpoints_and_gates.gate_deleted', {gate_name: gate.name}),
          })
          this.set_reload_required()
        })
        .catch(error => {
          this.show_error_message(error)
        })
      },
    gates_by_checkpoint_id: function (checkpoint_id) {
        let gates_in_checkpoint = []
        for (let gate of this.gates) {
          if (gate.checkpoint_id === null) continue
          if (gate.checkpoint_id['$oid'] === checkpoint_id['$oid']) {
            gates_in_checkpoint.push(gate)
          }
        }
        return gates_in_checkpoint
    },
    gate_checkpoint_name: function (gate) {
      return gate.checkpoint_id === null ? i18n.t('general.none') :
          this.checkpoints.find(chp => chp._id['$oid'] === gate.checkpoint_id['$oid']).name
    },
    set_reload_required: function () {
      this.$store.state.loading_overlay.reload_required = true
    },
    all_addressees_external_ids_array: function () {
        let addressees_external_ids_array = []
          this.addressees.forEach(item => {
            addressees_external_ids_array.push(item['external_id'])
          })
        return addressees_external_ids_array
    },
    set_all_addressees_selection_status: function (all_addressees_selected) {
      if (all_addressees_selected) {
        this.edited_gate.addressees_external_ids = this.all_addressees_external_ids_array()
      } else {
        this.edited_gate.addressees_external_ids = []
      }
    },
    ...mapActions(['setSnackbar'])
  },
  computed: {
    form_checkpoint_editor_title: function () {
      let text_add_ap = i18n.t('pages.checkpoints.dialog.add_checkpoint')
      let text_edit_ap = i18n.t('pages.checkpoints.dialog.edit_checkpoint')
      return this.edited_checkpoint_index === -1 ? text_add_ap : text_edit_ap
    },
    form_gate_editor_title: function () {
      let text_add_gate = i18n.t('pages.checkpoints.dialog.add_gate')
      let text_edit_gate = i18n.t('pages.checkpoints.dialog.edit_gate')
      return this.edited_gate_index === -1 ? text_add_gate : text_edit_gate
    },

    form_aps_table_data: function () {
      let checkpoints = []
      for (let checkpoint of this.checkpoints) {
        let checkpoint_gates = []
        let gates = this.gates_by_checkpoint_id(checkpoint._id)
        for (let gate of gates) {
          checkpoint_gates.push(gate)
        }
        checkpoint['gates'] = checkpoint_gates
        checkpoints.push(checkpoint)
      }
      return checkpoints
    },
    form_gates_table_data: function () {
      // if (!this.gates || !this.cams || !this.relays) return
      let all_gates = []
      for (let gate of this.gates) {
        gate['cams'] = this.cams_by_gate_id(gate._id)
        gate['relays'] = this.relays_by_gate_id(gate._id)
        all_gates.push(gate)
      }
      return all_gates
    },
    // all_addressees_selected: {
    //   get() {
    //     return this.edited_gate.addressees_external_ids.length === this.addressees.length
    //   },
    //   set() {
    //   }
    // },
    ...mapGetters(['loadingOverlay'])
  },

  watch: {
    checkpoint_edit_dialog: function (val) {
      this.$refs.checkpoint_edit_valid.resetValidation()
      !val && this.close_checkpoint_editor()
    },
    gate_edit_dialog: function (val) {
      this.$refs.gate_edit_valid.resetValidation()
      setTimeout(() => {
        this.$refs.gate_select.isMenuActive = false
      }, 10)
      !val && this.close_gate_editor()
    }
  }

}
</script>

<style lang="scss">
.button_title {
  font-family: Roboto,serif;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;

  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  text-transform: uppercase;

  color: #000000;

  opacity: 0.54;
}
.tab-font {
  font-family: Open Sans,serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 149.8%;
  color: #2D2B3D;
  text-transform: none;
  letter-spacing: 0.05rem;
}
</style>